// @ts-ignore
/* eslint-disable */
import request from './request';

/**编辑账号  */
export async function updateUser(values) {
    return request.post('/system/updateUser', values);
}

/**编辑角色  */
export async function updateRole(values) {
    return request.post('/system/updateRole', values);
}

/**配置菜单  */
export async function setMenu(values) {
    return request.post('/system/setMenu', values);
}

/**查询账号  */
export async function getUserPage(values) {
    return request.post('/system/getUserPage', values);
}

/**查询角色  */
export async function getRolePage(values) {
    return request.post('/system/getRolePage', values);
}

/**获取角色菜单  */
export async function getRoleMenu(values) {
    return request.post('/system/getRoleMenu', values);
}

/**查询菜单树  */
export async function getMenuTree(values) {
    return request.post('/system/getMenuTree', values);
}

/**获取全部菜单  */
export async function getMenuList(values) {
    return request.post('/system/getMenuList', values);
}

/**获取全部菜单-平铺  */
export async function getRoleMenuList(values) {
    return request.post('/system/getRoleMenuList', values);
}

/**查询字典  */
export async function getDictPage(values) {
    return request.post('/system/getDictPage', values);
}

/**启用禁用账号  */
export async function enableUser(values) {
    return request.post('/system/enableUser', values);
}

/**删除账号  */
export async function deleteUser(values) {
    return request.post('/system/deleteUser', values);
}

/**删除角色  */
export async function deleteRole(values) {
    return request.post('/system/deleteRole', values);
}

/**删除字典  */
export async function deleteDict(values) {
    return request.post('/system/deleteDict', values);
}

/**新增账号  */
export async function addUser(values) {
    return request.post('/system/addUser', values);
}

/**新增角色  */
export async function addRole(values) {
    return request.post('/system/addRole', values);
}

/**新增字典  */
export async function addOrUpdateDict(values) {
    return request.post('/system/addOrUpdateDict', values);
}

/**账号详情  */
export async function getUserInfo(id) {
    return request.get(`/system/getUserInfo/${id}`);
}


/**查询模板  */
export async function getTemplatesPage(values) {
    return request.post('/encourageTemplates/getTemplatesPage', values);
}

/**新增-编辑模板  */
export async function addOrUpTemplates(values) {
    return request.post('/encourageTemplates/addOrUpTemplates', values);
}

/**删除模板  */
export async function deleteTemplates(values) {
    return request.post('/encourageTemplates/deleteTemplates', values);
}

/**课程详情  */
export async function courseInfo(id) {
    return request.get(`/course/info/${id}`);
}

/**删除课程  */
export async function delCourse(id) {
    return request.get(`/course/del/${id}`);
}

/**查询用户详情  */
export async function mobileUserInfo(id) {
    return request.get(`/mobileUser/info/${id}`);
}

/**添加患者家属  */
export async function addFamily(values) {
    return request.post('/mobileUser/addFamily', values);
}

/**操作日志  */
export async function getOperationLogPage(values) {
    return request.post('/system/operationLogPage', values);
}

/**亲属日志操作日志  */
export async function getFamilyLog(values) {
    return request.post('/system/familyLog', values);
}

/**导出日志  */
export async function getLogExcel(values) {
    return request.post('/system/logExcel', values, {
        responseType: 'blob', // 指定响应类型为二进制流
    });
}






/**编辑动作模板  */
export async function updateCourseTrainingTemplate(values) {
    return request.post('/courseTrainingTemplate/update', values);
}

/**动作模板列表  */
export async function getCourseTrainingTemplateList(values) {
    return request.post('/courseTrainingTemplate/list', values);
}

/**新增动作模板  */
export async function addCourseTrainingTemplate(values) {
    return request.post('/courseTrainingTemplate/add', values);
}

/**同步课程动作  */
export async function syncCourseTraining(templateId) {
    return request.get(`/courseTrainingTemplate/syncCourseTraining/${templateId}`);
}

/**动作模板详情  */
export async function courseTrainingTemplateInfo(id) {
    return request.get(`/courseTrainingTemplate/info/${id}`);
}

/**删除动作模板  */
export async function delCourseTrainingTemplate(id) {
    return request.get(`/courseTrainingTemplate/del/${id}`);
}



/**修改当前账号密码  */
export async function updateUserPassword(values) {
    return request.post('/system/updateUserPassword', values);
}